export const checkConditionalLogic = (attributes, logic) => {


    if (!Array.isArray(logic) || logic.length === 0) return true;

    const normalize = (val) => {
        if (val === "true") return true;
        if (val === "false") return false;
        return val;
    };

    return logic.some((group) =>
        group.every((rule) => {

            const fieldValue = normalize(attributes[rule.field] ?? '');
            const expectedValue = normalize(rule.value);


            switch (rule.operator) {
                case '==': return fieldValue == expectedValue;
                case '!=': return fieldValue != expectedValue;
                case '>': return parseFloat(fieldValue) > parseFloat(expectedValue);
                case '<': return parseFloat(fieldValue) < parseFloat(expectedValue);
                case '>=': return parseFloat(fieldValue) >= parseFloat(expectedValue);
                case '<=': return parseFloat(fieldValue) <= parseFloat(expectedValue);
                default: return false;
            }
        })
    );
};